/**
 * Handles the password input show/hide event.
 */

document.addEventListener("DOMContentLoaded", () => {
  init();
});

const init = () => {
  const $passwordToggles = document.querySelectorAll(".password-visibility-toggle");

  $passwordToggles.forEach(($passwordToggle) => {
    $passwordToggle.addEventListener("click", (e: any) => {
      const $wrapper = e.target.closest(".input-wrapper");
      const $input = $wrapper.querySelector("input");
      const isShow = $input.type === "password";
      $input.type = isShow ? "text" : "password";
      if (isShow) {
        $passwordToggle.innerHTML = window.iconPasswordShow;
      } else {
        $passwordToggle.innerHTML = window.iconPasswordHide;
      }
    });
  });
};
